import axios from 'axios';
import {backendHost} from '../../../../store/config';

const getPresentList = (params) => {
    return axios.get(`${backendHost}/api/admin/present/list`, {params});
};

export {
    getPresentList
}